import AWS from "aws-sdk";
import { LOGGER_AWS_KINESIS_REGION, LOGGER_AWS_ID_POOL } from "@tt-app/constants";

const credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: LOGGER_AWS_ID_POOL
});

const awsConfig = {
  region: LOGGER_AWS_KINESIS_REGION,
  credentials
};

AWS.config.update(awsConfig);

export const kinesis = new AWS.Kinesis();
